import React, { Component } from "react";
import { Dimensions, StyleSheet, Text, View } from "react-native";
import AutoHeightImage from "react-native-auto-height-image";

import { Header } from "../components";
import DependencyList from "../components/DependencyList";
import { connect } from "react-redux";
import { getBaseUrl } from "../helpers/storage";
import fonts from "../constants/fonts";

const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  contentContainer: {
    paddingVertical: 30,
    paddingHorizontal: 5,
    backgroundColor: "#FFF",
    borderTopEndRadius: 30,
    borderTopStartRadius: 30
  },
  imageContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center"
  },
  text: {
    ...fonts.regular,
    fontSize: 22,
    textAlign: "center",
    marginTop: 10,
    marginHorizontal: 15,
    marginBottom: 30
  }
});

class AskScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dependencies: []
    };
  }

  async fetchDependencies() {
    const token = this.props.token;

    const ra = await fetch(getBaseUrl() + "info/dependency", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const ja = await ra.json();

    if (ja["status"] === "error") {
      this.props.screenProps.onClose();
    } else {
      this.setState({
        dependencies: ja["data"]
      });
    }
  }

  componentDidMount() {
   // this.promise = this.fetchDependencies();

    // set static data
    this.setState({
      dependencies: [{
        fullName: "Orang Tua",
        dependent: "parents"
      }, {
        fullName: "Pasangan",
        dependent: "partner"
      }, {
        fullName: "Anak",
        dependent: "children"
      }]
    })
  }

  _handlePress = () => {
    this.props.navigation.goBack();
  };

  render() {
    return (
      <View
        style={[
          styles.container,
          { backgroundColor: this.props.themeColors.primary }
        ]}
      >
        <Header
          onPress={this._handlePress}
          position="start"
          text="Batal"
          theme="light"
        />
        <View style={styles.imageContainer}>
          <AutoHeightImage
            width={Dimensions.get("window").width - 120}
            source={require("../assets/illustrations/ask.png")}
          />
        </View>
        <View style={styles.contentContainer}>
          <Text
            style={[
              styles.text,
              { color: this.props.themeColors.darkestPrimary }
            ]}
          >
            Untuk siapakah konsultasi ini?
          </Text>

          <DependencyList
            data={this.state.dependencies}
            onSelect={(dependent) => {
              this.props.navigation.replace("Symptoms", {
                dependent,
                patientId: this.props.navigation.state.params.patientId
              });
            }}
          />
        </View>
      </View>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(AskScreen);
